module.exports = __webpack_public_path__ + "img/team-member-bg.4045783a.png";